import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  insurerStateAll: [],
  insurerState: {},
  currentPage: 1,
  totalPages: 1,
  rowsPerPage: 10,
  sortBy: "name",
  sortOrder: "asc",
};

const insurerStateSlice = createSlice({
  name: "insurerState",
  initialState,
  reducers: {
    setInsurerStateAll: (state, action) => {
      state.generalStateAll = action.payload;
    },
    setInsurerState: (state, action) => {
      state.generalState = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setTotalPages: (state, action) => {
      state.totalPages = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
  },
});

export const {
  setInsurerStateAll,
  setInsurerState,
  setCurrentPage,
  setTotalPages,
  setRowsPerPage,
} = insurerStateSlice.actions;

export default insurerStateSlice.reducer;
